import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Fieldset = styled('fieldset')`
  margin-top: 3rem;
  border: 1px solid ${props => props.theme.palette.grey[300]};
  border-radius: ${props => props.theme.borderRadii.md};
  padding: 3rem 1rem;
  legend {
    background-color: white;
    color: ${props => props.theme.colors.primary};
    padding: 0 0.5rem;
    font-weight: 600;
  }
`;

const FilerLegend = ({ children }) => {
  return (
    <Fieldset>
      <legend>Filters</legend>
      {children}
    </Fieldset>
  );
};

FilerLegend.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FilerLegend;
